export const environment = {
    production: false,
    oAuthApiUrl: 'https://oauth.api.rivalforge.com/',
    platformUrl: 'https://realtime.api.rivalforge.com/',
    messengerUrl: "https://realtime.api.rivalforge.com/",
    chatUrl: "https://realtime.api.rivalforge.com/",
    voiceUrl: "https://voice.h5arena.com/voice",
    stripePublishableKey: "pk_test_51U0q4pCIybDFDaGtzOHuX3OG9J8tQp0ey6pY0LeKYl0Km5lOs73jxP5QA94G1ZKbiCrfoj9czI0MGtDs6790ChyY00YxpNKFAN"
};